<template>
  <div>
    <Dialog
      v-model:visible="shouldShowDialog"
      header="Confirm delete client"
      :modal="true"
      class="p-fluid"
      @hide="hideDialog"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span>
          Are you sure you want to delete the client with ID {{ clientId }}?
        </span>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-secondary"
          role="hide-dialog"
          :disabled="isLoading"
          @click="hideDialog"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          class="p-button-primary"
          role="delete-client"
          :disabled="isLoading"
          :loading="isLoading"
          @click="deleteSingleClient"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import useClient from '@/use/useClient'
import useClientEvent from '@/use/useClientEvent'
import { ref, computed, watch } from 'vue'

export default {
  name: 'ClientDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    clientId: {
      type: Number,
      default: null
    }
  },
  emits: ['hideDialog', 'clearDeletedClientIdFromSelection'],
  setup(props, { emit }) {
    const { fetchClients, deleteClient, isLoading } = useClient()
    const { deleteClientEvent } = useClientEvent()
    const shouldShowDialog = ref(false)

    const isVisible = computed({
      get() {
        return shouldShowDialog.value
      },
      set(value) {
        shouldShowDialog.value = value
      }
    })
    watch(
      () => props.visible,
      (value) => {
        isVisible.value = value
      },
      { immediate: true }
    )

    const showDialog = () => {
      shouldShowDialog.value = true
    }
    const hideDialog = () => {
      shouldShowDialog.value = false
      emit('hideDialog')
    }

    const deleteSingleClient = async () => {
      await deleteClientEvent(props.clientId)
      await deleteClient(props.clientId)
      fetchClients()
      hideDialog()
      emit('clearDeletedClientIdFromSelection', props.clientId)
    }

    return {
      shouldShowDialog,
      showDialog,
      hideDialog,
      isLoading,
      deleteSingleClient
    }
  }
}
</script>
